<template>
	<div class="position-relative height-100dvh">
		<NcdTopContainer v-if="showMainPage" />
		<!-- <mobHeader v-if="viewMainDashboard" /> -->
		<div class="mobile-header justify-content-start" v-if="!showMainPage">
			<template>
				<img
					@click="
						!showMainPage
							? ((showMainPage = true),
							  (showAllSwitch = false),
							  (showForm = false),
							  (displayInvoice = false),
							  (showPassword = false),
							  (showAllDevices = false),
							  (showallcheckbox = false),
							  (showverificationcode = false),
							  (showQuery = false),
							  (raiseQuery = false),
							  (changePassword = false))
							: goback()
					"
					class="ml-3 mr-3"
					src="../../assets/mobile/dashboard/blueBackArrow.svg"
					alt=""
				/>
				<span class="mb-header-txt" v-if="showMainPage">Account Settings</span>
				<span class="mb-header-txt" v-if="showAllSwitch"> Visibility</span>
				<span class="mb-header-txt" v-if="displayInvoice"
					><div class="d-flex justify-content-between align-items-center">
						<div class="mr-3">Track Tickets</div>
						<b-button
							class="candash-addBtn ml-5 pointer"
							@click="showReportModal = true"
						>
							Raise a Query
						</b-button>
					</div></span
				>
				<span class="mb-header-txt" v-if="showForm"> Personal Data</span>
				<span class="mb-header-txt" v-if="showPassword || changePassword">{{
					hasPassword ? "Basic Authentication" : "Set Password"
				}}</span>
				<span class="mb-header-txt" v-if="showAllDevices">Device Activity</span>
				<span
					class="mb-header-txt"
					v-if="showallcheckbox || showverificationcode"
					>Delete Account</span
				>
				<span class="mb-header-txt" v-if="showQuery">Raise Query</span>
			</template>
		</div>

		<div
			v-if="showMainPage"
			class="mobile-body app-bottom-padding"
			style="height: calc(100dvh - (60px + env(safe-area-inset-top)))"
		>
			<div class="mb-white-body">
				<div
					class="d-flex align-items-center justify-content-between"
					@click="personalData()"
				>
					<div class="d-flex align-items-center">
						<div>
							<img
								class="mr-2"
								src="../../assets/mobile/accset/personalData.svg"
								alt=""
							/>
						</div>
						<div class="mb-black-bold-2">Personal Data</div>
					</div>
					<div>
						<img src="../../assets/mobile/dashboard/mb-rightArrow.svg" alt="" />
					</div>
				</div>
				<div
					v-if="userInfo.authType == 'keycloak'"
					class="d-flex align-items-center justify-content-between mt-3"
					@click="basicAuthentication()"
				>
					<div class="d-flex align-items-center">
						<div>
							<img
								class="mr-2"
								src="../../assets/mobile/accset/basicauth.svg"
								alt=""
							/>
						</div>
						<div class="mb-black-bold-2">Basic Authentication</div>
					</div>
					<div>
						<img src="../../assets/mobile/dashboard/mb-rightArrow.svg" alt="" />
					</div>
				</div>
				<div
					v-if="userInfo.authType == 'keycloak' && notGoogleLogin"
					class="d-flex align-items-center justify-content-between mt-3"
					@click="deviceActivity()"
				>
					<div class="d-flex align-items-center">
						<div>
							<img
								class="mr-2"
								src="../../assets/mobile/accset/deviceact.svg"
								alt=""
							/>
						</div>
						<div class="mb-black-bold-2">Device Activity</div>
					</div>
					<div>
						<img src="../../assets/mobile/dashboard/mb-rightArrow.svg" alt="" />
					</div>
				</div>
				<div
					class="d-flex justify-content-between mt-3"
					@click="showvisibility()"
				>
					<div class="d-flex">
						<div>
							<img
								class="ml-1 mr-2"
								src="../../assets/mobile/accset/visibile.svg"
								alt=""
							/>
						</div>
						<div>
							<div class="mb-black-bold-2">Visibility</div>
							<div class="mb-grey-txt pr-4">
								Make certain sections visible from My profile
							</div>
						</div>
					</div>
					<div>
						<img src="../../assets/mobile/dashboard/mb-rightArrow.svg" alt="" />
					</div>
				</div>
				<div class="d-flex justify-content-between mt-3">
					<div class="d-flex">
						<div>
							<img
								class="mr-2"
								src="../../assets/mobile/accset/disableAcc.svg"
								alt=""
							/>
						</div>
						<div>
							<div class="mb-black-bold-2">Disable Account</div>
							<div class="mb-grey-txt pr-4">
								Temporarily disable your account to restrict access and maintain
								privacy; enable anytime for full access.
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-end">
						<b-form-checkbox
							switch
							v-model="disableAcc"
							@change="disableclick"
							class="mb-profile-switch"
						></b-form-checkbox>
					</div>
				</div>
				<div class="d-flex justify-content-between mt-3" @click="showdelete()">
					<div class="d-flex">
						<div>
							<img
								class="mr-2"
								src="../../assets/mobile/accset/deleteAcc.svg"
								alt=""
							/>
						</div>
						<div>
							<div class="mb-black-bold-2">Delete Account</div>
							<div class="mb-grey-txt pr-4">
								Account deletion is irreversible. Once the process is complete,
								all data associated with your account cannot be recovered.
							</div>
						</div>
					</div>
					<div>
						<img src="../../assets/mobile/dashboard/mb-rightArrow.svg" alt="" />
					</div>
				</div>
				<div
					v-if="candidateTicketHistory && candidateTicketHistory.length"
					class="d-flex justify-content-between mt-3"
					@click="showInvoice()"
				>
					<div class="d-flex">
						<div>
							<img
								class="ml-1 mr-2"
								src="../../assets/mobile/accset/Invoice.svg"
								alt=""
							/>
						</div>
						<div>
							<div class="mb-black-bold-2">Track Tickets</div>
							<div class="mb-grey-txt pr-4">Track & manage your tickets</div>
						</div>
					</div>
					<div>
						<img src="../../assets/mobile/dashboard/mb-rightArrow.svg" alt="" />
					</div>
				</div>
				<div
					v-else
					class="d-flex justify-content-between mt-3"
					@click="showQueryTab()"
				>
					<div class="d-flex align-items-center">
						<div>
							<img
								class="mr-2"
								src="../../assets/New Profile/raise-query.svg"
								alt=""
							/>
						</div>
						<div>
							<div class="mb-black-bold-2">Raise Query</div>
							<div class="mb-grey-txt pr-4">
								Raise a query about your account
							</div>
						</div>
					</div>
					<div>
						<img src="../../assets/mobile/dashboard/mb-rightArrow.svg" alt="" />
					</div>
				</div>
			</div>
		</div>
		<div v-if="displayInvoice" class="mobile-body app-bottom-padding">
			<!-- IF NO DATA -->

			<!-- <div
				class="mb-white-body d-flex flex-column align-items-center justify-content-center"
			>
				<img src="../../assets/mobile/accset/noInvoice.svg" alt="" />
				<span class="upCandDoc-unselected-box-head mt-2"
					>You haven’t made any transactions yet.</span
				>
			</div> -->
			<div class="overflow-auto gap-2 d-flex flex-column">
				<div
					v-for="(ticket, index) in candidateTicketHistory"
					:key="index"
					class="mb-acsec-bluecard"
				>
					<section class="d-flex align-items-center justify-content-between">
						<div class="fam-mont fw-B color-2c2c2c fs-14">
							{{ ticket.ticketID }}
						</div>
						<div>
							<img
								@click="showTicketDetails(ticket)"
								src="../../assets/mobile/accset/previewEye.svg"
								alt=""
							/>
						</div>
					</section>
					<hr class="my-2" style="border-top: 1px solid #888888" />
					<section class="d-flex align-items-center justify-content-between">
						<div>
							<div class="fam-mont fs-10 text-primary fw-LM">Category:</div>
							<div
								class="fam-mont fs-13 fw-M"
								:class="{
									'text-reviews': ticket.module === '1',
									'text-community': ticket.module === '2',
									'text-interview': ticket.module === '3',
									'text-platform': ticket.module === '5',
									'text-course':
										ticket.module !== '1' &&
										ticket.module !== '2' &&
										ticket.module !== '3',
								}"
							>
								{{
									ticket.module === "1"
										? "Reviews"
										: ticket.module === "2"
										? "Community"
										: ticket.module === "3"
										? "Interview"
										: ticket.module === "5"
										? "Platform"
										: "Course"
								}}
							</div>
						</div>
						<div>
							<div class="fam-mont fs-10 text-primary fw-LM">Status:</div>
							<div
								class="fam-mont fs-13 fw-M"
								:class="
									ticket.status === '5'
										? 'text-closed'
										: ticket.status === '4'
										? 'text-appealed'
										: 'text-open'
								"
							>
								{{
									ticket.status === "2"
										? "Processing"
										: ticket.status === "3"
										? "Rejected"
										: ticket.status === "4"
										? "Appeal"
										: ticket.status === "5"
										? "Closed"
										: "Open"
								}}
								&nbsp;<span
									v-if="ticket.status == '5'"
									class="fw-R color-2c2c2c"
									>{{ formatDate(ticket.updatedAt) }}
								</span>
							</div>
						</div>
					</section>
					<section class="mt-2">
						<div class="fam-mont fs-10 text-primary fw-LM">Reason:</div>
						<div class="fam-mont fs-13 fw-R color-2c2c2c">
							{{ ticket.title }}
						</div>
					</section>
					<section class="mt-2 fw-R fs-12 fam-lato text-8cgrey">
						{{ formatDate(ticket.createdAt) }}
					</section>
					<!-- <div class="d-flex align-items-center justify-content-between">
						<div class="d-flex align-items-center w85">
							<div class="mb-light-txt width-45">
								<div>Ticket ID</div>
								<div class="mt-1">Category</div>
							</div>
							<div class="mb-dark-txt">
								<div>{{ ticket.ticketID }}</div>
								<div class="mt-1">
									{{
										ticket.module === "1"
											? "Reviews"
											: ticket.module === "2"
											? "Community"
											: ticket.module === "3"
											? "Interview"
											: "Course"
									}}
								</div>
							</div>
						</div>
					</div> -->
					<!-- <b-collapse v-model="openInvoiceCollapse[index - 1]">
						<div class="d-flex w85 mt-1">
							<div class="mb-light-txt width-45">Reason</div>
							<div class="mb-dark-txt">{{ ticket.title }}</div>
						</div>
						<div class="d-flex w85 mt-1">
							<div class="mb-light-txt width-45">Raised On</div>
							<div class="mb-dark-txt">{{ formatDate(ticket.createdAt) }}</div>
						</div>
						<div class="d-flex w85 mt-1">
							<div class="mb-light-txt width-45">Status</div>
							<div class="mb-dark-txt">
								{{
									ticket.status === "2"
										? "Processing"
										: ticket.status === "3"
										? "Rejected"
										: ticket.status === "4"
										? "Appeal"
										: ticket.status === "5"
										? "Closed"
										: "Open"
								}}
								<span v-if="ticket.status === '5'"
									>{{ formatDate(ticket.updatedAt) }}
								</span>
							</div>
						</div>
						
					</b-collapse> -->
				</div>
			</div>
		</div>
		<div v-if="showPersonalDataShimmer">
			<div class="mobile-inner-body p-3">
				<div class="mt-1">
					<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
				</div>
				<div class="mt-5">
					<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
				</div>
				<div class="mt-5">
					<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
				</div>
				<div class="mt-5">
					<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
				</div>
			</div>
		</div>
		<div
			v-else-if="!showPersonalDataShimmer && showForm"
			class="mobile-body app-bottom-padding"
		>
			<div class="mobile-inner-body p-3">
				<div class="position-relative">
					<div class="mb-modal-label">
						First Name<span class="asterik">*</span>
					</div>
					<div class="mt-1">
						<b-form-input
							:class="
								editProfile && $v.profileDetails.firstName.$error
									? 'mb-profile-inputField-error'
									: ''
							"
							placeholder="Enter First Name"
							class="mb-profile-inputField"
							type="text"
							v-model="profileDetails.firstName"
							:disabled="editProfile == false"
							@keypress="alphabetsOnly"
							spellCheck="false"
						></b-form-input>
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							editProfile &&
							$v.profileDetails.firstName.$dirty &&
							!$v.profileDetails.firstName.required
						"
					>
						Required
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							$v.profileDetails.firstName.$dirty &&
							!$v.profileDetails.firstName.maxLength
						"
					>
						Exceeded the max char length of 38
					</div>
					<div
						v-if="
							editProfile &&
							$v.profileDetails.firstName.$dirty &&
							!$v.profileDetails.firstName.alphaNumeric
						"
						class="candash-errortxt errortxt-pos"
					>
						Invalid Name
					</div>
				</div>
				<div class="mt-3 position-relative">
					<div class="mb-modal-label">
						Last Name<span class="asterik">*</span>
					</div>
					<div class="mt-1">
						<b-form-input
							:class="
								editProfile && $v.profileDetails.lastName.$error
									? 'mb-profile-inputField-error'
									: ''
							"
							placeholder="Enter First Name"
							class="mb-profile-inputField"
							type="text"
							v-model="profileDetails.lastName"
							:disabled="editProfile == false"
							@keypress="alphabetsOnly"
							spellCheck="false"
						></b-form-input>
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							editProfile &&
							$v.profileDetails.lastName.$dirty &&
							!$v.profileDetails.lastName.required
						"
					>
						Required
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							$v.profileDetails.lastName.$dirty &&
							!$v.profileDetails.lastName.maxLength
						"
					>
						Exceeded the max char length of 38
					</div>
					<div
						v-if="
							editProfile &&
							$v.profileDetails.lastName.$dirty &&
							!$v.profileDetails.lastName.alphaNumeric
						"
						class="candash-errortxt errortxt-pos"
					>
						Invalid Name
					</div>
				</div>
				<div class="mt-3" v-if="userInfo.authType == 'keycloak'">
					<div class="mb-modal-label">Phone Number</div>
					<div class="mt-1">
						<!-- :class="
								editProfile && $v.profileDetails.phoneNumber.$error
									? 'mb-profile-inputField-error'
									: ''
							" -->
						<b-form-input
							placeholder="Enter First Name"
							class="mb-profile-inputField"
							type="text"
							maxlength="10"
							v-model="profileDetails.phoneNumber"
							@keypress="numbersOnly"
							disabled
							spellCheck="false"
						></b-form-input>
					</div>
					<!-- <div
						class="candash-errortxt errortxt-pos"
						v-if="
							editProfile &&
							$v.profileDetails.phoneNumber.$dirty &&
							!$v.profileDetails.phoneNumber.required
						"
					>
						Required
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							($v.profileDetails.phoneNumber.$dirty &&
								!$v.profileDetails.phoneNumber.numeric) ||
							(!$v.profileDetails.phoneNumber.alpha &&
								$v.profileDetails.phoneNumber.required)
						"
					>
						Invalid Phone Number
					</div> -->
				</div>
				<div class="mt-3">
					<div class="mb-modal-label">Email</div>
					<div class="mt-1">
						<b-form-input
							disabled
							placeholder="abc@dfg.com"
							class="mb-profile-inputField"
							v-model="profileDetails.email"
							spellCheck="false"
						></b-form-input>
					</div>
				</div>
			</div>
			<div class="mobile-footer pr-3">
				<div v-if="editProfile" class="d-flex">
					<b-button
						class="mb-cancelBtn mr-3"
						:disabled="profileLoader == true"
						@click="(editProfile = false), reassignDetails()"
						>Cancel</b-button
					>
					<div class="position-relative">
						<b-button
							:class="
								profileLoader
									? 'mb-addBtn opac-5 defaultCursor '
									: 'mb-addBtn pointer'
							"
							@click="saveProfileDetails()"
							><span :class="!profileLoader ? '' : 'text-blue'"
								>Save</span
							></b-button
						>
						<div v-if="profileLoader" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
				<div v-else-if="!editProfile && userInfo.authType == 'keycloak'">
					<b-button class="mb-addBtn ml-3" @click="editPersonalData()"
						>Edit</b-button
					>
				</div>
			</div>
		</div>
		<div v-else-if="showQuery" class="mobile-body app-bottom-padding">
			<div class="mobile-inner-body-2">
				<div class="position-relative h-100">
					<div
						class="mt-1 w-100 text-center h-100 d-flex flex-column align-items-center justify-content-center"
						v-if="!raiseQuery"
					>
						<div
							v-if="showPersonalDataShimmer"
							class="mt-3 d-flex justify-content-center w-100"
						>
							<b-skeleton-img
								no-aspect
								height="155px"
								width="268px"
							></b-skeleton-img>
						</div>
						<img src="@/assets/New Profile/Query-img.svg" alt="" />
						<!-- <div
									class="mt-3 d-flex justify-content-center raise-button-shimmer"
									v-if="showPersonalDataShimmer"
								>
									<b-skeleton type="button"></b-skeleton>
								</div> -->
						<div class="mt-3 d-flex justify-content-center w-100">
							<b-button
								class="candash-addBtn ml-3 pointer"
								@click="showReportModal = true"
							>
								Raise Query
							</b-button>
						</div>
					</div>
					<div
						class="w-100 relativeclass h-100 overflow-hidden"
						v-if="raiseQuery"
					>
						<div
							class="col align-items-start p-3"
							style="height: calc(100dvh - (145px + env(safe-area-inset-top)))"
						>
							<div class="row">
								<div
									class="pd-txt mb-modal-label"
									style="margin-top: 10px; margin-left: 5px"
								>
									Explain Your Concern<span style="color: #eb0002">*</span>
								</div>
							</div>
							<div>
								<b-form-textarea
									class="mb-profile-inputField"
									rows="5"
									max-rows="5"
									no-resize
									placeholder="Enter"
									v-model="otherReason"
									@input="updateCharacterCount"
									:maxlength="200"
								></b-form-textarea>
								<div class="started-at">
									{{ charactersLeft }} characters left
								</div>
							</div>
						</div>

						<div
							class="d-flex align-items-center justify-content-end pr-3 mobjd-applied-footer"
						>
							<b-button
								class="candash-cancelBtn pointer"
								@click="raiseQuery = false"
							>
								Cancel
							</b-button>

							<b-button
								class="candash-addBtn pointer"
								@click="submitQuery"
								:disabled="otherReason == ''"
							>
								Submit
							</b-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="showPassword" class="mobile-body app-bottom-padding">
			<div class="mobile-inner-body p-3">
				<div>
					<div class="mb-modal-label">Password</div>
					<div class="mt-1">
						<b-form-input
							disabled
							placeholder="**********"
							class="mb-profile-inputField"
						></b-form-input>
					</div>
				</div>
			</div>
			<div class="mobile-footer pr-3">
				<b-button
					class="mb-addBtn ml-3"
					@click="
						(changePassword = true),
							(showPassword = false),
							(showCurrentPassword = false),
							(showNewPassword = false),
							(passwordDetails.newPswd = ''),
							(hasUppercase = false),
							(hasLowercase = false),
							(hasSplcharacter = false),
							(hasNumber = false),
							(matchCriteria = false)
					"
					>Reset</b-button
				>
				<!-- <b-button class="mb-addBtn ml-3">Edit</b-button> -->
			</div>
		</div>
		<div v-if="changePassword" class="mobile-body app-bottom-padding">
			<div class="mobile-inner-body p-3">
				<div v-if="hasPassword" class="position-relative">
					<div class="mb-modal-label">
						Current Password<span class="asterik">*</span>
					</div>
					<div class="mt-1 position-relative">
						<b-form-input
							:class="
								$v.passwordDetails.currentPassword.$error ||
								checkCurrentPsw == true
									? 'mb-profile-inputField-error'
									: ''
							"
							placeholder="Enter Current Password"
							class="mb-profile-inputField"
							:type="showCurrentPassword ? 'text' : 'password'"
							v-model="passwordDetails.currentPassword"
							:autocomplete="showCurrentPassword ? 'off' : 'new-password'"
						></b-form-input>
						<img
							@click="togglePasswordVisibility('showCurrentPassword')"
							v-if="showCurrentPassword"
							class="cd-hlepsec-searchicon"
							src="../../assets/mobile/accset/mb-view-2.svg"
							alt=""
						/>
						<img
							v-else
							@click="togglePasswordVisibility('showCurrentPassword')"
							class="cd-hlepsec-searchicon pointer"
							src="../../assets/New Profile/not-view-icon.svg"
							alt=""
						/>
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							$v.passwordDetails.currentPassword.$dirty &&
							!$v.passwordDetails.currentPassword.required
						"
					>
						Required
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							passwordDetails.currentPassword != '' && checkCurrentPsw == true
						"
					>
						Current password is wrong
					</div>
				</div>
				<div class="mt-3 position-relative">
					<div class="mb-modal-label">
						New Password<span class="asterik">*</span>
					</div>
					<div class="mt-1 position-relative">
						<b-form-input
							:class="{
								'mb-profile-inputField-error':
									$v.passwordDetails.newPswd.$error ||
									(checkNewPsw == false && passwordDetails.newPswd != ''),
								'pr-55':
									checkNewPsw == true &&
									passwordDetails.newPswd != '' &&
									hasUppercase &&
									hasLowercase &&
									hasNumber &&
									hasSplcharacter,
							}"
							placeholder="Enter New Password"
							v-model="passwordDetails.newPswd"
							@input="validatePassword"
							:type="showNewPassword ? 'text' : 'password'"
							:autocomplete="showNewPassword ? 'off' : 'new-password'"
							class="mb-profile-inputField"
						></b-form-input>
						<img
							v-if="showNewPassword"
							@click="togglePasswordVisibility('showNewPassword')"
							class="cd-hlepsec-searchicon"
							src="../../assets/mobile/accset/mb-view-2.svg"
							alt=""
						/>
						<img
							v-else
							@click="togglePasswordVisibility('showNewPassword')"
							class="cd-hlepsec-searchicon pointer"
							src="../../assets/New Profile/not-view-icon.svg"
							alt=""
						/>
						<img
							class="mbPro-hlepsec-searchicon"
							v-if="
								checkNewPsw == true &&
								passwordDetails.newPswd != '' &&
								hasUppercase &&
								hasLowercase &&
								hasNumber &&
								hasSplcharacter
							"
							src="../../assets/New Profile/match.svg"
							alt=""
						/>

						<img
							v-else-if="passwordDetails.newPswd != '' && checkNewPsw == false"
							class="mbPro-hlepsec-searchicon"
							src="../../assets/New Profile/no-match.svg"
							alt=""
						/>
					</div>
					<div
						v-if="passwordDetails.newPswd != '' && checkNewPsw == false"
						class="candash-errortxt errortxt-pos"
					>
						New Password cannot be same as current password
					</div>
					<!-- <div class="candash-errortxt errortxt-pos">Error txt</div> -->
				</div>
				<div
					v-if="passwordDetails.newPswd == '' || checkNewPsw == true"
					class="d-flex flex-wrap align-items-center mt-2"
				>
					<div class="">
						<div v-if="hasUppercase" class="d-flex align-items-center">
							<img src="../../assets/New Profile/select-uppercase.svg" alt="" />
							<div class="mb-green-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								1 Upper case
							</div>
						</div>
						<div v-else class="d-flex align-items-center">
							<img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
							<div class="mb-red-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								1 Upper case
							</div>
						</div>
					</div>

					<div class="ml-2">
						<div
							v-if="hasLowercase && passwordDetails.newPswd != ''"
							class="d-flex align-items-center"
						>
							<img src="../../assets/New Profile/select-uppercase.svg" alt="" />
							<div class="mb-green-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								3 Lower case
							</div>
						</div>
						<div v-else class="d-flex align-items-center">
							<img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
							<div class="mb-red-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								3 Lower case
							</div>
						</div>
					</div>
					<div class="ml-2">
						<div v-if="hasSplcharacter" class="d-flex align-items-center">
							<img src="../../assets/New Profile/select-uppercase.svg" alt="" />
							<div class="mb-green-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								1 Special character
							</div>
						</div>
						<div v-else class="d-flex align-items-center">
							<img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
							<div class="mb-red-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								1 Special character
							</div>
						</div>
					</div>
					<div class="mt-1">
						<div v-if="hasNumber" class="d-flex align-items-center">
							<img src="../../assets/New Profile/select-uppercase.svg" alt="" />
							<div class="mb-green-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								1 Number
							</div>
						</div>
						<div v-else class="d-flex align-items-center">
							<img src="../../assets/New Profile/reject-uppercase.svg" alt="" />
							<div class="mb-red-font ml-1">
								<!-- for reject uppercase font ---- reject-uppercase-font -->
								1 Number
							</div>
						</div>
					</div>
				</div>
				<div class="mt-3 position-relative">
					<div class="mb-modal-label">
						Confirm Password<span class="asterik">*</span>
					</div>
					<div class="mt-1">
						<b-form-input
							:class="
								$v.passwordDetails.confirmPswd.$error ||
								(passwordDetails.confirmPswd != '' &&
									!passwordsMatch &&
									passwordDetails.newPswd != '')
									? 'mb-profile-inputField-error'
									: ''
							"
							placeholder="Confirm Password"
							class="mb-profile-inputField"
							v-model="passwordDetails.confirmPswd"
							type="password"
							:autocomplete="showConfirmPassword ? 'off' : 'new-password'"
						></b-form-input>

						<img
							class="match-hlepsec-searchicon"
							v-if="
								passwordsMatch &&
								passwordDetails.confirmPswd != '' &&
								passwordDetails.newPswd != '' &&
								hasUppercase &&
								hasLowercase &&
								hasNumber &&
								hasSplcharacter
							"
							src="../../assets/New Profile/match.svg"
							alt=""
						/>

						<img
							class="match-hlepsec-searchicon"
							v-else-if="
								!passwordsMatch &&
								passwordDetails.confirmPswd != '' &&
								passwordDetails.newPswd != ''
							"
							src="../../assets/New Profile/no-match.svg"
							alt=""
						/>
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							$v.passwordDetails.confirmPswd.$dirty &&
							!$v.passwordDetails.confirmPswd.required
						"
					>
						Required
					</div>
					<div
						class="candash-errortxt errortxt-pos"
						v-if="
							!passwordsMatch &&
							passwordDetails.confirmPswd != '' &&
							passwordDetails.newPswd != ''
						"
					>
						Password doesn't match
					</div>
				</div>
			</div>
			<div class="mobile-footer pr-3">
				<b-button
					class="mb-cancelBtn"
					@click="
						cancelResetPswd(), (showMainPage = true), (changePassword = false)
					"
					>Cancel</b-button
				>
				<div class="position-relative">
					<b-button
						:class="
							Loader ? 'mb-addBtn opac-5 defaultCursor ' : 'mb-addBtn pointer'
						"
						@click="resetPwd()"
						><span :class="!Loader ? '' : 'text-blue'">Save</span></b-button
					>
					<div v-if="Loader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</div>
		<div v-if="showDeviceActivityShimmer">
			<div
				v-for="(i, index) in loopvar"
				:key="index"
				class="mb-white-card p-3 position-relative mb-3"
			>
				<div class="">
					<!-- <div class="mb-yellow-tag yellow-tag-pos">Currently Active</div> -->
					<div>
						<div class="d-flex align-items-center mb-mobile-txt-2 mt-1">
							<b-skeleton type="avatar"></b-skeleton>
							<b-skeleton class="ml-3 w-85"></b-skeleton>
						</div>
						<div class="mb-line-div mt-2"></div>
						<b-row class="mt-2">
							<b-col>
								<b-skeleton class="ml-3"></b-skeleton>
								<b-skeleton class="ml-3"></b-skeleton>
							</b-col>
						</b-row>
						<b-row class="mt-2">
							<b-col cols="6">
								<b-skeleton class="ml-3 w-85"></b-skeleton>
								<b-skeleton class="ml-3 w-85"></b-skeleton>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</div>
		<div
			v-else-if="showAllDevices && !showDeviceActivityShimmer"
			class="mobile-body app-bottom-padding p-0"
		>
			<div class="h91 p-3 overflow-auto">
				<div
					v-if="Object.keys(currentlyTrue).length != 0"
					class="mb-white-card p-3 position-relative mb-3"
				>
					<div
						class="mb-yellow-tag yellow-tag-pos"
						v-if="currentlyTrue.current"
					>
						Currently Active
					</div>
					<div class="d-flex align-items-center mb-mobile-txt-2 mt-1">
						<img
							class="mr-2"
							v-if="
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Mobile Safari'
							"
							src="../../assets/mobile/accset/mb-safari.svg"
							alt=""
						/>
						<img
							class="mr-2"
							v-else-if="
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Chrome' ||
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Chrome Mobile' ||
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Chrome Mobile iOS' ||
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Edge'
							"
							src="../../assets/mobile/accset/mb-chrome.svg"
							alt=""
						/>
						<img
							class="mr-2"
							v-else-if="
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Firefox'
							"
							src="../../assets/mobile/accset/mb-firefox.svg"
							alt=""
						/>
						<img
							class="mr-2"
							v-else-if="
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Safari'
							"
							src="../../assets/mobile/accset/mb-safari.svg"
							alt=""
						/>
						<img
							class="mr-2"
							v-else-if="
								currentlyTrue.browser.slice(
									0,
									currentlyTrue.browser.indexOf('/')
								) == 'Opera'
							"
							src="../../assets/mobile/accset/mb-opera.svg"
							alt=""
						/>
						<img
							class="mr-2"
							v-else
							src="../../assets/mobile/accset/mb-default.svg"
							alt=""
						/>
						{{ currentlyTrue.browser }}
					</div>
					<div class="mb-line-div mt-2"></div>
					<b-row class="mt-2">
						<b-col>
							<div class="mb-black-txt">Started at</div>
							<div class="mb-black-txt-3 mt-1">
								{{ currentlyTrue.started }}
							</div>
						</b-col>
						<b-col>
							<div class="mb-black-txt">Expires at</div>
							<div class="mb-black-txt-3 mt-1">
								{{ currentlyTrue.expires }}
							</div>
						</b-col>
					</b-row>
					<div class="mt-2 d-flex justify-content-between">
						<div>
							<div class="mb-black-txt">Last accessed on</div>
							<div class="mb-black-txt-3 mt-1">
								{{ currentlyTrue.lastAccess }}
							</div>
						</div>
						<div
							class="d-flex align-items-end mb-descriptn-txt-4 pointer"
							@click="signOutConfirm(currentlyTrue)"
						>
							Log Out
						</div>
					</div>
				</div>
				<div v-for="(i, index) in device" :key="index">
					<div
						v-for="(j, index2) in i.sessions"
						:key="index2"
						:class="
							!j.current ? 'mb-white-card p-3 position-relative mb-3' : ''
						"
					>
						<!-- <div class="mb-yellow-tag yellow-tag-pos">Currently Active</div> -->
						<div v-if="!j.current && !showDeviceActivityShimmer">
							<div class="d-flex align-items-center mb-mobile-txt-2 mt-1">
								<img
									class="mr-2"
									v-if="
										j.browser.slice(0, j.browser.indexOf('/')) ==
										'Mobile Safari'
									"
									src="../../assets/mobile/accset/mb-safari.svg"
									alt=""
								/>
								<img
									class="mr-2"
									v-else-if="
										j.browser.slice(0, j.browser.indexOf('/')) == 'Chrome' ||
										j.browser.slice(0, j.browser.indexOf('/')) ==
											'Chrome Mobile' ||
										j.browser.slice(0, j.browser.indexOf('/')) ==
											'Chrome Mobile iOS' ||
										j.browser.slice(0, j.browser.indexOf('/')) == 'Edge'
									"
									src="../../assets/mobile/accset/mb-chrome.svg"
									alt=""
								/>
								<img
									class="mr-2"
									v-else-if="
										j.browser.slice(0, j.browser.indexOf('/')) == 'Firefox'
									"
									src="../../assets/mobile/accset/mb-firefox.svg"
									alt=""
								/>
								<img
									class="mr-2"
									v-else-if="
										j.browser.slice(0, j.browser.indexOf('/')) == 'Safari'
									"
									src="../../assets/mobile/accset/mb-safari.svg"
									alt=""
								/>
								<img
									class="mr-2"
									v-else-if="
										j.browser.slice(0, j.browser.indexOf('/')) == 'Opera'
									"
									src="../../assets/mobile/accset/mb-opera.svg"
									alt=""
								/>
								<img
									class="mr-2"
									v-else
									src="../../assets/mobile/accset/mb-default.svg"
									alt=""
								/>
								{{ j.browser }}
							</div>
							<div class="mb-line-div mt-2"></div>
							<b-row class="mt-2">
								<b-col>
									<div class="mb-black-txt">Started at</div>
									<div class="mb-black-txt-3 mt-1">
										{{ j.started }}
									</div>
								</b-col>
								<b-col>
									<div class="mb-black-txt">Expires at</div>
									<div class="mb-black-txt-3 mt-1">
										{{ j.expires }}
									</div>
								</b-col>
							</b-row>
							<div class="mt-2 d-flex justify-content-between">
								<div>
									<div class="mb-black-txt">Last accessed on</div>
									<div class="mb-black-txt-3 mt-1">
										{{ j.lastAccess }}
									</div>
								</div>
								<div
									class="d-flex align-items-end mb-descriptn-txt-4"
									@click="signOutConfirm(j)"
								>
									Log Out
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mobile-footer pr-3">
				<!-- <b-button class="mb-cancelBtn">Cancel</b-button> -->
				<b-button class="mb-addBtn ml-3" @click="$bvModal.show('suresignout')"
					>Log out all devices</b-button
				>
				<!-- <b-button class="mb-addBtn ml-3">Edit</b-button> -->
			</div>
		</div>
		<div v-if="showVisibilityShimmer" class="mobile-body app-bottom-padding">
			<div class="mb-white-body overflow-auto">
				<div class="mb-4">
					<div class="mb-grey-txt-2 pr-4">
						<b-skeleton class="w-75"></b-skeleton>
					</div>
				</div>
				<div v-for="(i, index) in loop" :key="index">
					<div class="mt-4">
						<div>
							<b-skeleton class=""></b-skeleton>
						</div>
					</div>
					<div class="mb-line-div mt-2"></div>
				</div>
			</div>
		</div>
		<div
			v-else-if="showAllSwitch && !showVisibilityShimmer"
			class="mobile-body app-bottom-padding"
		>
			<div class="mb-white-body overflow-auto">
				<div class="d-flex justify-content-between mb-4">
					<div class="mb-grey-txt-2 pr-4">
						Make certain sections visible from My profile
					</div>
					<div>
						<b-form-checkbox
							switch
							class="mb-profile-switch-big"
							v-model="visibility"
							@change="allUserSettings()"
						></b-form-checkbox>
					</div>
				</div>
				<div v-for="(i, index) in visibilityList" :key="index">
					<div class="d-flex align-items-center justify-content-between mt-3">
						<div class="mb-mobile-txt-2">
							{{ i.formName }}
						</div>
						<div>
							<b-form-checkbox
								switch
								class="mb-profile-switch"
								v-model="i.status"
								@change="changeUserSettings('parent')"
							></b-form-checkbox>
						</div>
					</div>
					<div v-if="i.hasVisibilityFields" class="mb-line-div mt-2"></div>
					<template v-if="i.hasVisibilityFields">
						<div
							v-for="(field, fieldIndex) in i.visibilityFieldsList"
							:key="fieldIndex"
						>
							<div class="d-flex align-items-center mt-3">
								<div>
									<b-form-checkbox
										switch
										class="mb-profile-switch"
										v-model="field.status"
										@change="changeUserSettings('child')"
									></b-form-checkbox>
								</div>
								<div class="mb-mobile-txt-2">
									{{ field.label }}
								</div>
							</div>
						</div>
					</template>
					<div class="mb-line-div mt-2"></div>
				</div>
			</div>
		</div>

		<!-- <div v-if="showAllSwitch" class="mobile-body">
      <div class="mb-white-body overflow-auto">
        <div class="d-flex justify-content-between mb-4">
          <div class="mb-grey-txt-2 pr-4">
            Make certain sections visible from My profile
          </div>
          <div>
            <b-form-checkbox
              switch
              class="mb-profile-switch-big"
              v-model="visibility"
              @change="allUserSettings()"
            ></b-form-checkbox>
          </div>
        </div>
        <div v-for="(i, index) in visibilityList" :key="index">
          <div class="d-flex align-items-center justify-content-between mt-3">
            <div class="mb-mobile-txt-2">{{ i.formName }}</div>
            <div>
              <b-form-checkbox
                switch
                class="mb-profile-switch"
                v-model="i.status"
                @change="changeUserSettings()"
              ></b-form-checkbox>
            </div>
          </div>
          <div class="mb-line-div mt-2"></div>
        </div>
      </div>
    </div> -->
		<div v-if="showallcheckbox" class="mobile-body app-bottom-padding">
			<div class="mobile-inner-body pad-12">
				<div class="mb-mobile-txt-2">Delete Account</div>
				<div class="mb-grey-txt mt-1">
					Account deletion is irreversible. Once the process is complete, all
					data associated with your account cannot be recovered.
				</div>
				<div class="mb-new-blacktxt mt-4">
					{{ username }},
					<span class="mb-new-blacktxt-2">We're sorry to see you go</span>
				</div>
				<div class="mb-grey-txt mt-1 mb-3">
					Tell us reason for closing your account
				</div>
				<div class="candash-checkbox-parent">
					<b-form-checkbox
						size="sm"
						v-for="option in delDetailsOptions"
						:key="option.value"
						v-model="selected"
						:value="option.value"
						:unchecked-value="null"
						:id="'checkbox-' + option.value"
					>
						<div class="mb-modal-label">
							{{ option.text }}
						</div>
					</b-form-checkbox>
				</div>
				<div class="pl-3 mt-2" v-if="showOtherReasonTextarea">
					<b-form-textarea
						:class="$v.otherReason.$error ? 'candash-textarea-error' : ''"
						class="candash-textarea"
						type="text"
						placeholder="Enter Reason"
						rows="3"
						max-rows="4"
						v-model="otherReason"
						@input="updateCharacterCount"
						:maxlength="200"
					>
					</b-form-textarea>
					<div
						class="pl-3 candash-errortxt"
						v-if="$v.otherReason.$dirty && !$v.otherReason.required"
					>
						This field is required if you select others
					</div>
					<div class="pl-3 candash-character-left" v-else>
						{{ charactersLeft }} characters left
					</div>
				</div>
			</div>
			<div class="mobile-footer-2 pr-3">
				<b-button
					class="mb-cancelBtn"
					@click="
						(showallcheckbox = false),
							(showMainPage = true),
							(otherReason = ''),
							$v.otherReason.$reset()
					"
					>Cancel</b-button
				>
				<b-button
					class="mb-addBtn"
					:disabled="selected.length == 0"
					@click="verifyEmailAddress()"
					>Verify Email</b-button
				>
				<!-- <b-button class="mb-addBtn ml-3">Edit</b-button> -->
			</div>
		</div>
		<div v-if="showverificationcode" class="mobile-body app-bottom-padding">
			<div class="mobile-inner-body pad-12">
				<div class="mb-mobile-txt-2">Delete Account</div>
				<div class="mb-grey-txt mt-1">
					Account deletion is irreversible. Once the process is complete, all
					data associated with your account cannot be recovered.
				</div>

				<div class="mb-grey-txt mt-4 mb-3">
					Tell us reason for closing your account
				</div>
				<div class="mt-3 position-relative">
					<div class="mb-modal-label">Verification Code</div>
					<div class="mt-1">
						<b-form-input
							:class="
								otpWrong || otpExists || otpExpired
									? 'mb-profile-inputField-error'
									: ''
							"
							placeholder="Enter Code"
							class="mb-profile-inputField"
							v-model="verificationCode"
							type="text"
							maxlength="6"
							@keypress="numbersOnly"
						></b-form-input>
						<div
							v-if="verificationCode != null && otpWrong"
							class="candash-errortxt mt-1 ml-2"
						>
							OTP is invalid.
						</div>
						<div
							v-else-if="verificationCode != null && otpExists"
							class="candash-errortxt mt-1 ml-2"
						>
							OTP does not exist.
						</div>
						<div
							v-else-if="verificationCode != null && otpExpired"
							class="candash-errortxt mt-1 ml-2"
						>
							OTP is expired.
						</div>
					</div>
					<!-- <div class="candash-errortxt errortxt-pos">Error txt</div> -->
				</div>
			</div>
			<div class="mobile-footer-2 pr-3">
				<b-button
					@click="(showMainPage = true), (showverificationcode = false)"
					class="mb-cancelBtn"
					>Cancel</b-button
				>
				<b-button
					class="mb-addBtn ml-3"
					@click="(deviceSignOut = false), deleteAccount(), signOutAllDevices()"
					:disabled="verificationCode == null"
					>Delete</b-button
				>
			</div>
		</div>
		<b-modal
			v-model="deletedaccount"
			size="md"
			centered
			hide-footer
			hide-header
			@hidden="deletedaccount = false"
		>
			<div class="d-flex flex-column align-items-center p-2">
				<div @click="deletedaccount = false">
					<img src="../../assets/mobile/accset/mb-delete.svg" alt="" />
				</div>
				<div class="mb-header-txt mt-3">Your account is deleted</div>
				<div class="upCandDoc-unselected-box-head-2 mt-1">
					Thanks for using our product
				</div>
				<div class="mt-4">
					<b-button
						class="mb-addBtn"
						@click="(deletedaccount = false), (deviceSignOut = false), logout()"
						>Okay</b-button
					>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="suresignout"
			v-model="suresignout"
			size="md"
			centered
			hide-footer
			hide-header
			@hidden="suresignout = false"
		>
			<div class="d-flex flex-column align-items-center p-2">
				<div>
					<img src="../../assets/mobile/accset/mb-signout-2.svg" alt="" />
				</div>
				<div class="mb-header-txt mt-3 text-center">
					Are you sure you want to log out of
					{{ selectedDevice == null ? "all devices" : "this device" }}?
				</div>
				<div class="mt-4 d-flex">
					<b-button
						class="mb-cancelBtn mr-3"
						@click="(selectedDevice = null), $bvModal.hide('suresignout')"
						>Cancel</b-button
					>
					<div class="position-relative">
						<b-button
							class="mb-addBtn"
							:class="
								loading ? 'loader-class-signout defaultCursor' : 'pointer'
							"
							@click="
								selectedDevice == null
									? ((deviceSignOut = true), signOutAllDevices())
									: signOut(selectedDevice)
							"
						>
							<span v-if="!loading">Log Out</span></b-button
						>
						<div v-if="loading" class="loader-pos-new" style="left: 14px">
							<Loader />
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			v-model="warningaccount"
			size="md"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			@hidden="
				warningaccount = false;
				disableAcc = false;
			"
		>
			<div class="d-flex flex-column align-items-center pb-2 position-relative">
				<div class="pointer mb-cross-icon-pos">
					<img
						@click="(warningaccount = false), (disableAcc = false)"
						class="rotate-on-hover"
						src="../../assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
				<div>
					<img src="../../assets/mobile/accset/mb-warn.svg" alt="" />
				</div>
				<div class="mb-header-txt mt-1">Warning : Account Disabling</div>
				<div class="upCandDoc-unselected-box-head-2 mt-2">
					Disabling your account will:
				</div>
				<div
					class="upCandDoc-unselected-box-head-2 mb-modal-list mt-3 w-100 d-flex justify-content-start"
				>
					<ul>
						<li>Restrict job-related activities</li>
						<li>Hide your profile from all users</li>
						<li>Recruiters cannot search your profile</li>
					</ul>
				</div>
				<div class="mt-4">
					<b-button class="mb-addBtn" @click="disableAccount()">Okay</b-button>
				</div>
			</div>
		</b-modal>
		<b-modal
			v-model="signedOut"
			id="signedout-mb"
			size="md"
			centered
			hide-footer
			hide-header
			@hidden="signedOut = false"
		>
			<div class="d-flex flex-column align-items-center p-2">
				<div>
					<img src="../../assets/toast/successBig.svg" alt="" />
				</div>
				<div class="mb-header-txt mt-2 text-center">
					You have been signed out of all devices.
				</div>
				<div class="upCandDoc-unselected-box-head-2 mt-1"></div>
				<div class="mt-4">
					<b-button class="mb-addBtn" @click="signedOut = false">Okay</b-button>
				</div>
			</div>
		</b-modal>

		<b-modal
			id="openTicketDetails"
			v-model="openTicketDetails"
			centered
			hide-footer
			hide-header
		>
			<div class="d-flex align-items-center justify-content-between">
				<div class="fw-LM fs-16 fam-lato">
					<span class="color-595959">Ticket ID:</span>
					<span class="text-blue">{{ ticketInfo.ticketID }}</span>
				</div>
				<img
					@click="openTicketDetails = false"
					class="rotate-on-hover"
					src="../../assets/newdesign/dashboard/blueCross.svg"
					alt=""
				/>
			</div>
			<hr class="my-2" style="border-top: 1px solid #888888" />
			<section>
				<div class="color-3a3c40 fam-mont">
					<div class="fw-LM fs-13">Raised On</div>
					<div class="fw-M fs-14">{{ formatDate(ticketInfo.createdAt) }}</div>
				</div>
				<div class="color-3a3c40 fam-mont mt-2">
					<div class="fw-LM fs-13">Status</div>
					<div
						class="fw-M fs-14"
						:class="
							ticketInfo.status === '5'
								? 'text-closed'
								: ticketInfo.status === '4'
								? 'text-appealed'
								: 'text-open'
						"
					>
						{{
							ticketInfo.status === "2"
								? "Processing"
								: ticketInfo.status === "3"
								? "Rejected"
								: ticketInfo.status === "4"
								? "Appeal"
								: ticketInfo.status === "5"
								? "Closed"
								: "Open"
						}}<span class="fw-R color-2c2c2c" v-if="ticketInfo.status == '5'">
							(on {{ formatDate(ticketInfo.updatedAt) }} )</span
						>
					</div>
				</div>
				<div class="color-3a3c40 fam-mont mt-2">
					<div class="fw-LM fs-13">Category</div>
					<div
						class="fw-M fs-14"
						:class="{
							'text-reviews': ticketInfo.module === '1',
							'text-community': ticketInfo.module === '2',
							'text-interview': ticketInfo.module === '3',
							'text-platform': ticketInfo.module === '5',
							'text-course':
								ticketInfo.module !== '1' &&
								ticketInfo.module !== '2' &&
								ticketInfo.module !== '3',
						}"
					>
						{{
							ticketInfo.module === "1"
								? "Reviews"
								: ticketInfo.module === "2"
								? "Community"
								: ticketInfo.module === "3"
								? "Interview"
								: ticketInfo.module === "5"
								? "Platform"
								: "Course"
						}}
					</div>
				</div>
				<div class="color-3a3c40 fam-mont mt-2">
					<div class="fw-LM fs-13">Reason</div>
					<div class="fw-M fs-14">
						{{ ticketInfo.title }}
					</div>
				</div>
				<div class="color-3a3c40 fam-mont mt-2">
					<div class="fw-LM fs-13">Remark</div>
					<div class="fw-M fs-14 word-break">
						{{ ticketInfo.remarks }}
					</div>
				</div>

				<div
					class="fam-mont fw-500 fs-13 text-3A3C40 mt-3 d-flex"
					v-if="closedActivity(ticketInfo) && ticketInfo.status == '5'"
				>
					<span class="stroke-line mr-3 mt-2"></span>Ticket Closing Remarks<span
						class="stroke-line ml-3 mt-2"
					></span>
				</div>

				<div
					class="mt-3"
					v-if="closedActivity(ticketInfo) && ticketInfo.status == '5'"
				>
					<b-card
						no-body
						class="overflow-hidden w-100 lb-right-card position-relative p-3 admin-card"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div class="fw-LM fs-16 fam-lato">
								<img src="@/assets/newdesign/dashboard/admin.svg" alt="" />
								<span class="admin ml-2">Super Admin:</span>
							</div>
							<span>{{
								formatDate(closedActivity(ticketInfo).activityAt)
							}}</span>
						</div>
						<hr class="my-2" style="border-top: 1px solid #888888" />
						<!-- title -->
						<div class="fam-mont fw-400 fs-13 mt-2">Reason:</div>
						<div class="fam-lato fw-400 fs-13 text-darkgrey">
							{{ closedActivity(ticketInfo).title }}
						</div>

						<div class="fam-mont fw-400 fs-13 mt-2">Remark:</div>
						<div class="fam-lato fw-400 fs-14 lh-18 text-darkgrey">
							{{ closedActivity(ticketInfo).remarks }}
						</div>
					</b-card>
				</div>
			</section>

			<div class="mt-4 d-flex justify-content-center">
				<b-button class="mb-addBtn" @click="openTicketDetails = false"
					>Okay</b-button
				>
			</div>
		</b-modal>
		<ReportIssueModal
			v-if="showReportModal"
			:showModal="showReportModal"
			:reportIssue="reportIssue"
			:isCommon="true"
			:interviewId="userInfo.userID"
			@closeReport="showReportModal = false"
			@updateReport="viewTicketHistory"
		/>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Loader from "../../components/fixedcomponents/Loader.vue";
import ReportIssueModal from "@/components/JobProgress/ReportIssueModal.vue";

const qs = require("qs");
import errorModal from "../../components/mixin/toast";
import successModal from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import {
	required,
	email,
	maxLength,
	numeric,
	helpers,
	requiredIf,
} from "vuelidate/lib/validators";

import {
	getDeviceActivity,
	postCandInfo,
	signOutDevices,
	signOutAllDevices,
	// getApplications,
	getProfileDetails,
	userLogin,
	getUserDetails,
	getUserSettings,
	changeUserSettings,
	resetPassword,
	saveProfileDetails,
	userInfo,
	deleteAccount,
	raiseQuery,
	viewTicketHistory,
	checkCandidateSignin,
} from "../../utils/apiFunctions";
import { Capacitor } from "@capacitor/core";
import { notGoogleLogin } from "@/utils/tokenCheck.js";
import NcdTopContainer from "../NewCandidateDashboard/NcdTopContainer.vue";

export default {
	name: "MobileProfile",

	mixins: [errorModal, successModal],
	components: {
		Spinner,
		Loader,
		ReportIssueModal,
		NcdTopContainer,
	},
	data() {
		return {
			showReportModal: false,
			reportIssue: {
				1: "Didn’t receive timely support",
				2: "Difficult to contact support",
				3: "Issue unresolved",
				4: "Faced a technical error or bug",
				5: "Login or access issue",
				6: "Page not loading properly",
				7: "Notification/email not received",
				8: "Poor content quality",
				9: "Platform is slow or unresponsive",
				10: "Others",
			},
			raiseQuery: false,
			signedOut: false,
			deviceSignOut: false,
			matchCriteria: false,
			isDisabledvar: false,
			isDisabled: false,
			fullName: "",
			Loader: false,
			hasUppercase: false,
			hasLowercase: false,
			hasSplcharacter: false,
			hasNumber: false,
			selectedDevice: null,
			showVisibilityShimmer: false,
			showDeviceActivityShimmer: false,
			showPersonalDataShimmer: false,
			delDetailsOptions: [
				{ text: "Platform not user-friendly ", value: "1" },
				{
					text: "Found an alternative platform",
					value: "2",
				},
				{ text: "Technical issues", value: "3" },
				{
					text: "Unwanted emails and notifications",
					value: "4",
				},
				{ text: "Privacy concerns", value: "5" },
				{ text: "Other (please specify)", value: "6" },
			],
			visibilityList: [],
			passwordsMatch: false,
			disableAcc: false,

			visibility: false,
			verificationCode: null,
			reassign: {
				email: "",
				firstName: "",
				lastName: "",
				phoneNumber: "",
			},
			currentlyTrue: {},

			otpWrong: false,
			otpExpired: false,
			otpExists: false,
			profileLoader: false,
			loopvar: 3,
			loop: 8,
			loopvar2: 15,
			displayInvoice: false,
			openInvoiceCollapse: Array(15).fill(false),
			showverificationcode: false,
			warningaccount: false,
			suresignout: false,
			deletedaccount: false,
			showallcheckbox: false,
			showAllSwitch: false,
			showAllDevices: false,
			hasPassword: true,
			changePassword: false,
			showPassword: false,
			showForm: false,
			showMainPage: false,
			openProfile: false,
			openBasic: false,
			openDevice: false,
			openApp: false,
			changepassword: false,
			show: false,
			showCurrentPassword: false,
			showNewPassword: false,
			showConfirmPassword: false,
			loading: false,
			showProfInfo: false, // Show Profile Info
			showBasicAut: false, // Show Basic Authentication
			resetPassword: false, // Flag for resetting password
			showDevAct: false, // Show Device Activity
			showApp: false, // Show Application
			LoaderStatus: false, // Flag to indicate loading state
			checkCurrentPsw: false,
			checkNewPsw: false,
			editProfile: false,
			checkConfirmPsw: false,
			email: "",
			first_Name: "",
			last_Name: "",
			device: [],
			// Form fields for password reset
			passwordDetails: {
				confirmPswd: "",
				newPswd: "",
				currentPassword: "",
			},
			givenPsw: "",

			// Profile related fields
			profileDetails: {
				email: "",
				firstName: "",
				lastName: "",
				phoneNumber: "",
			},
			selected: [],
			otherReason: "",
			maxCharacters: 200,

			// Arrays to store device activity and application data
			deviceCheck: [],
			getApplication: [],
			showQuery: false,
			candidateTicketHistory: [],
			openTicketDetails: false,
			ticketInfo: {},
		};
	},
	computed: {
		notGoogleLogin,
		charactersLeft() {
			return this.maxCharacters - this.otherReason.length;
		},
		// Mapping Vuex getters to computed properties
		...mapGetters("userVUEX", {
			User: "getUserEmail",
			selTheme: "getSelectedTheme",
			userInfo: "getUserInfo",
		}),
		...mapGetters("candidateVUEX", {
			username: "getUserName",
		}),
		showOtherReasonTextarea() {
			return this.selected.includes("6");
		},
	},
	validations: {
		// Validation rules for form fields
		profileDetails: {
			firstName: {
				required,
				maxLength: maxLength(38),
				alphaNumeric: helpers.regex("alphaNumeric", /^[A-Za-z. ]*$/),
			},
			phoneNumber: {
				required,
				alpha: helpers.regex("alpha", /^[6-9]\d{9}$/),
				numeric,
			},

			lastName: {
				required,
				maxLength: maxLength(38),
				alphaNumeric: helpers.regex("alphaNumeric", /^[A-Za-z. ]*$/),
			},
		},
		passwordDetails: {
			confirmPswd: {
				required,
			},
			newPswd: {
				required,
			},
			currentPassword: {
				required: requiredIf(function () {
					return this.hasPassword;
				}),
			},
		},
		otherReason: {
			required: requiredIf(function () {
				return this.showOtherReasonTextarea;
			}),
		},
	},

	created() {
		this.viewTicketHistory();
		this.getUserSettings();
		this.checkUserHasPassword();
		this.showVisibilityShimmer = false;
		this.showDeviceActivityShimmer = false;
		this.showPersonalDataShimmer = false;
		this.showMainPage = true;
		if (this.$route.query.tab == "query") {
			this.showQueryTab();
			this.raiseQuery = true;
		}
		console.log(this.isDisabled, "this.isDisabled");
		console.log(this.isDisabledvar, "this.isDisabledvar");
	},
	watch: {
		verificationCode: function () {
			this.otpExists = false;
			this.otpExpired = false;

			this.otpWrong = false;
		},

		"passwordDetails.currentPassword": function () {
			this.checkCurrentPsw = false;

			if (
				this.passwordDetails.newPswd != this.passwordDetails.currentPassword
			) {
				this.checkNewPsw = true;
			} else {
				this.checkNewPsw = false;
			}
		},

		"passwordDetails.confirmPswd": function () {
			if (this.passwordDetails.newPswd == this.passwordDetails.confirmPswd) {
				this.passwordsMatch = true;
			} else {
				this.passwordsMatch = false;
			}
		},

		"passwordDetails.newPswd": function () {
			this.matchCriteria = false;
			if (this.passwordDetails.newPswd == this.passwordDetails.confirmPswd) {
				this.passwordsMatch = true;
			} else {
				this.passwordsMatch = false;
			}
			if (
				this.passwordDetails.newPswd != this.passwordDetails.currentPassword
			) {
				this.checkNewPsw = true;
			} else {
				this.checkNewPsw = false;
			}
		},
	},

	methods: {
		closedActivity(ticket) {
			if (!ticket || !ticket.activity) return null;

			const reversed = [...ticket.activity].reverse();
			return reversed.find((item) => item.status == "5") || null;
		},
		showTicketDetails(ticket) {
			this.openTicketDetails = true;
			this.ticketInfo = ticket;
		},
		formatDate(date) {
			if (!date) return "";
			if (date.includes(",")) {
				return date.slice(0, date.indexOf(","));
			}
			return date.slice(0, 10);
		},
		async submitQuery() {
			let payload = {
				concern: this.otherReason,
			};
			const res = await raiseQuery(payload);
			if (res.status == 200) {
				this.otherReason = "";
				this.raiseQuery = false;
				this.$bvModal.show("submitQuery");
				this.ticketId = response.data.data.ticketID;
			}
		},
		disableclick() {
			if (this.disableAcc == true) {
				this.warningaccount = true;
			} else {
				this.warningaccount = false;
				this.disableAccount();
			}
			console.log(this.disableAcc, "disaled");
		},
		alphabetsOnly(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				(charCode < 65 || charCode > 90) &&
				(charCode < 97 || charCode > 122) &&
				charCode !== 32 && // space
				charCode !== 46 // dot
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		numbersOnly(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				charCode > 31 &&
				(charCode < 48 || charCode > 57) &&
				charCode !== 46
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		showdelete() {
			(this.showallcheckbox = true),
				(this.showMainPage = false),
				(this.otherReason = ""),
				(this.selected = []),
				this.$v.otherReason.$reset();
		},
		showQueryTab() {
			this.showQuery = true;
			this.showMainPage = false;
		},
		showvisibility() {
			(this.showPersonalDataShimmer = false),
				(this.showAllSwitch = true),
				(this.showDeviceActivityShimmer = false),
				(this.showMainPage = false);
			this.getUserSettings();
		},
		showInvoice() {
			this.displayInvoice = true;
			this.showMainPage = false;
			// this.viewTicketHistory();
		},
		async viewTicketHistory() {
			const res = await viewTicketHistory();
			if (res.status == 200) {
				this.candidateTicketHistory = res.data.data;
			}
		},
		openCollapseInvoice(index) {
			// Toggle the collapse state for the specific index
			this.$set(
				this.openInvoiceCollapse,
				index,
				!this.openInvoiceCollapse[index]
			);
		},
		deviceActivity() {
			(this.showAllDevices = true),
				(this.showMainPage = false),
				(this.showPersonalDataShimmer = false);
			this.getDeviceActivity();
		},
		basicAuthentication() {
			this.showMainPage = false;
			this.showDeviceActivityShimmer = false;
			this.showVisibilityShimmer = false;
			this.showPersonalDataShimmer = false;
			this.cancelResetPswd();
			if (this.hasPassword) {
				this.showPassword = true;
			} else {
				// No password set — go straight to the form
				this.changePassword = true;
			}
		},
		personalData() {
			(this.showMainPage = false),
				(this.showForm = true),
				(this.showDeviceActivityShimmer = false),
				(this.showVisibilityShimmer = false);
			this.getprofileDetails();
		},
		goback() {
			this.$router.go(-1);
			// if (this.username == "") {
			// 	this.$router.go(-1);
			// } else {
			// 	this.$router.push({
			// 		name: "ViewPublicProfile",
			// 		params: {
			// 			username: this.username,
			// 		},
			// 	});
			// }
		},

		editPersonalData() {
			this.editProfile = true;
			this.reassign = JSON.parse(JSON.stringify(this.profileDetails));
			if (this.profileDetails.phoneNumber == "") {
				this.editPhn = true;
			}
		},
		async verifyEmailAddress() {
			this.verificationCode = null;
			this.$v.otherReason.$touch();

			if (!this.$v.otherReason.$invalid) {
				(this.showverificationcode = true), (this.showallcheckbox = false);
			}

			let type = {
				type: "delete-account",
			};
			const response = await deleteAccount(type);
			console.log(this.$v.otherReason.$invalid, "this.$v.otherReason.$invalid");
		},
		validatePassword() {
			this.hasUppercase = /^(.*[A-Z]){1,}.*$/.test(
				this.passwordDetails.newPswd
			);
			this.hasLowercase = /^(.*[a-z]){3}.*$/.test(this.passwordDetails.newPswd);
			this.hasSplcharacter =
				/^(.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]){1,}.*$/.test(
					this.passwordDetails.newPswd
				);
			this.hasNumber = /^(.*\d){1,}.*$/.test(this.passwordDetails.newPswd);
			if (
				this.passwordDetails.newPswd != this.passwordDetails.currentPassword
			) {
				this.checkNewPsw = true;
			} else {
				this.checkNewPsw = false;
			}
		},
		async disableAccount() {
			let payload = {
				isDisabled: !this.isDisabled,
			};
			const res = await changeUserSettings(payload);
			if (res.status == 200) {
				this.isDisabled = res.data.data.isDisabled;
				this.warningaccount = false;
				if (payload.isDisabled == false) {
					console.log("enal");
					this.successModal(
						"Successfully Enabled",
						"Your Account have been enabled"
					);
				}
				this.callingRegisterAPI();
				this.getUserSettings();
			}
		},
		updateCharacterCount() {
			this.$v.otherReason.$touch();
			if (this.charactersLeft < 0) {
				// Trim the input if the character limit is exceeded
				this.otherReason = this.otherReason.slice(0, this.maxCharacters);
			}
		},
		async logout() {
			// this.signOutAllDevices();
			let payload = {
				id: this.currentlyTrue.id,
			};
			await signOutDevices(payload);
			this.$socket.emit("signOut", {
				email: this.profileDetails.email,
				userid: payload,
			});
			localStorage.clear();
			this.$store.dispatch("userVUEX/LogOut");
			// this.$router.push(`/login?redirect=${this.$route.fullPath}`);
			location.reload();
		},
		async deleteAccount() {
			let payload = {
				isDeleted: {
					status: true,
					reasons: this.selected,
					otherReason: this.otherReason,
				},
				otp: parseInt(this.verificationCode),
			};
			const res = await changeUserSettings(payload);
			if (res.status == 200) {
				this.deletedaccount = true;
			} else if (res.status == 401) {
				this.otpWrong = true;
			} else if (res.status == 404) {
				this.otpExists = true;
			} else if (res.status == 410) {
				this.otpExpired = true;
			} else if (res.status == 500) {
				this.errorModal("Error", "Something went wrong"); // Show error toast
			}
		},
		handleScroll(event) {
			const stickyDivHeight = 0;
			const scrollTop = event.target.scrollTop + stickyDivHeight;

			if (scrollTop < this.$refs.personalData.offsetTop) {
				this.activeTab = "personalData";
			} else if (scrollTop < this.$refs.basicAuth.offsetTop) {
				this.activeTab = "basisAuthentication";
			} else if (scrollTop < this.$refs.deviceActivity.offsetTop) {
				this.activeTab = "deviceActivity";
			} else if (scrollTop < this.$refs.visibility.offsetTop) {
				this.activeTab = "visibility";
				this.activeSec = "visibility";
			} // const isAtBottom = scrollTop + windowHeight >= scrollHeight - 30;

			// if (isAtBottom) {
			//   this.activeTab = "deleteAccount";
			// }
		},

		navigate(name) {
			let element = null;

			if (name === "personalData" && this.$refs.personalData) {
				element = this.$refs.personalData;
				this.activeTab = "personalData";
			} else if (name === "basisAuthentication" && this.$refs.basicAuth) {
				element = this.$refs.basicAuth;
				this.activeTab = "basisAuthentication";
			} else if (name === "deviceActivity" && this.$refs.deviceActivity) {
				element = this.$refs.deviceActivity;
				this.activeTab = "deviceActivity";
			} else if (name === "visibility" && this.$refs.visibility) {
				element = this.$refs.visibility;
				this.activeTab = "visibility";
				this.activeSec = "visibility";
			} else if (name === "deleteAccount" && this.$refs.delete) {
				element = this.$refs.delete;
				this.activeTab = "deleteAccount";
				this.activeSec = "deleteAccount";
			}
			console.log("navigate - name:", name);
			console.log("navigate - element:", element);
			console.log("activeSec", this.activeSec);

			if (element) {
				console.log(element);
				element.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
			}
		},

		togglePasswordVisibility(field) {
			this[field] = !this[field];
		},
		cancelResetPswd() {
			this.$v.$reset();
			this.resetPassword = false;
			this.passwordDetails = {
				currentPassword: "",
				newPassword: "",
				confirmPswd: "",
			};
		},
		// Method to check if user has a password set
		async checkUserHasPassword() {
			try {
				const payload = { userID: this.userInfo.userID };
				const res = await checkCandidateSignin(payload);
				if (res.status == 200) {
					const hasPass = res.data.data?.hasPassword;
					this.hasPassword =
						hasPass === true || hasPass === undefined ? true : false;
				}
			} catch (error) {
				console.error("checkUserHasPassword error:", error);
			}
		},
		// Method to reset the password
		async resetPwd() {
			try {
				// Validate form fields
				this.$v.passwordDetails.$touch();

				if (this.hasPassword) {
					if (
						this.passwordDetails.newPswd != this.passwordDetails.currentPassword
					) {
						this.checkNewPsw = true;
					} else {
						this.checkNewPsw = false;
					}
				} else {
					this.checkNewPsw = true;
				}

				if (
					this.passwordDetails.confirmPswd != "" &&
					this.passwordDetails.newPswd != "" &&
					(!this.hasUppercase ||
						!this.hasLowercase ||
						!this.hasNumber ||
						!this.hasSplcharacter)
				) {
					this.matchCriteria = true;
				} else if (
					this.passwordDetails.confirmPswd != "" &&
					this.passwordDetails.newPswd != "" &&
					this.hasUppercase &&
					this.hasLowercase &&
					this.hasNumber &&
					this.hasSplcharacter
				) {
					this.matchCriteria = false;
				}

				// Check if form fields are not invalid
				if (
					!this.$v.passwordDetails.$invalid &&
					this.passwordsMatch == true &&
					this.checkNewPsw == true &&
					this.hasUppercase == true &&
					this.hasLowercase == true &&
					this.hasSplcharacter == true &&
					this.hasNumber == true &&
					this.matchCriteria == false
				) {
					this.Loader = true;
					let username = this.userInfo.email;

					if (!this.hasPassword) {
						// Set password flow: no current password needed
						const res = await resetPassword({
							email: username,
							password: this.passwordDetails.confirmPswd,
						});
						if (res.status == 200) {
							this.hasPassword = true;
							this.Loader = false;
							this.hasUppercase = false;
							this.hasLowercase = false;
							this.hasSplcharacter = false;
							this.hasNumber = false;
							this.$v.$reset();
							this.successModal("Success", "Password set successfully!");
							this.passwordDetails = {
								currentPassword: "",
								newPassword: "",
								confirmPswd: "",
							};
							this.changePassword = false;
							this.showMainPage = true;
						} else {
							this.Loader = false;
							this.errorModal("Error", "Something went wrong");
						}
					} else {
						// Normal flow: verify current password first
						let payload = qs.stringify({
							grant_type: "password",
							client_id: "vue-test-app",
							username: username,
							password: this.passwordDetails.currentPassword,
						});
						const res = await userLogin(payload);
						if (res.status == 200) {
							const res = await resetPassword({
								email: username,
								password: this.passwordDetails.confirmPswd,
							});
							if (res.status == 200) {
								this.showPassword = true;
								this.Loader = false;
								this.hasUppercase = false;
								this.hasLowercase = false;
								this.hasSplcharacter = false;
								this.hasNumber = false;
								this.$v.$reset();
								this.successModal(
									"Successfully updated",
									"Password have been updated"
								);
								this.passwordDetails = {
									currentPassword: "",
									newPassword: "",
									confirmPswd: "",
								};
								this.changePassword = false;
								this.showMainPage = true;
							} else if (res.status == 401) {
								this.checkCurrentPsw = true;
								this.errorModal("Error", "Something went wrong");
							}
						}
					}
				}
			} catch (error) {
				this.Loader = false;
				this.checkCurrentPsw = true;
				this.errorModal("Error", "Invalid user credentials");
				console.error("Error:", error);
			}
		},
		async getUserSettings() {
			if (this.showMainPage == false) {
				this.showVisibilityShimmer = true;
			}
			const res = await getUserSettings();
			if (res.status == 200) {
				this.isDisabledvar = res.data.data.isDisabled;
				this.isDisabled = res.data.data.isDisabled;
				console.log(this.isDisabledvar, "setin");
				if (this.isDisabledvar) {
					this.disableAcc = true;
				}
				this.showVisibilityShimmer = false;
			}

			this.userSettings = res.data.data.visibilityConfig;
			this.visibilityList = res.data.data.visibilityList;
			if (this.visibilityList.every((item) => item.status === false)) {
				this.visibility = false;
			} else if (this.visibilityList.every((item) => item.status === true)) {
				this.visibility = true;
			}
		},

		async allUserSettings() {
			try {
				this.visibilityList.forEach((item) => {
					item.status = this.visibility;

					if (
						item.hasVisibilityFields &&
						item.visibilityFieldsList.length > 0
					) {
						item.visibilityFieldsList.forEach((field) => {
							field.status = this.visibility;
						});
					}
				});

				const visibilityConfig = {};

				this.visibilityList.forEach((item) => {
					visibilityConfig[item.formID] = item.status;

					if (
						item.hasVisibilityFields &&
						item.visibilityFieldsList.length > 0
					) {
						let subFieldConfig = {};
						item.visibilityFieldsList.forEach((field) => {
							subFieldConfig[field.key] = field.status;
						});
						visibilityConfig[item.formID + "_Fields"] = subFieldConfig;
					}
				});

				const payload = {
					visibilityConfig,
				};

				await changeUserSettings(payload);
			} catch (error) {
				console.error("Error in allUserSettings:", error);
			}
		},

		async changeUserSettings(source = "child") {
			try {
				let visibilityConfig = {};

				this.visibilityList.forEach((item) => {
					if (source === "parent") {
						if (item.status && item.hasVisibilityFields) {
							item.visibilityFieldsList.forEach((field) => {
								field.status = true;
							});
						}
						if (!item.status && item.hasVisibilityFields) {
							item.visibilityFieldsList.forEach((field) => {
								field.status = false;
							});
						}
					}

					if (source === "child") {
						// When user toggles a child switch
						if (item.hasVisibilityFields && item.visibilityFieldsList.length) {
							const allOn = item.visibilityFieldsList.every(
								(field) => field.status
							);
							const allOff = item.visibilityFieldsList.every(
								(field) => !field.status
							);
							if (allOn) {
								item.status = true;
							} else if (allOff) {
								item.status = false;
							}
						}
					}

					visibilityConfig[item.formID] = item.status;

					if (item.hasVisibilityFields) {
						let subFieldConfig = {};
						item.visibilityFieldsList.forEach((field) => {
							subFieldConfig[field.key] = field.status;
						});
						visibilityConfig[item.formID + "_Fields"] = subFieldConfig;
					}
				});

				const allVisible = this.visibilityList.every((item) => item.status);
				const allHidden = this.visibilityList.every((item) => !item.status);
				this.visibility = allVisible
					? true
					: allHidden
					? false
					: this.visibility;

				await changeUserSettings({ visibilityConfig });
			} catch (error) {
				console.error("Error in changeUserSettings:", error);
			}
		},

		// Method to fetch profile details
		async getprofileDetails() {
			this.$v.profileDetails.$touch();

			console.log(this.showMainPage);

			try {
				this.showPersonalDataShimmer = true;

				// Call the API to get profile details
				const res = await getUserDetails();

				if (res.status == 200) {
					this.showPersonalDataShimmer = false;

					this.profileDetails.email = res.data.data.email;
					this.profileDetails.firstName = res.data.data.firstName;
					this.profileDetails.lastName = res.data.data.lastName;
					this.profileDetails.phoneNumber = res.data.data.phoneNumber;
					this.createdAt = res.data.data.createdAt;
					this.fullName =
						this.profileDetails.firstName + this.profileDetails.lastName;

					var dateObject = new Date(this.createdAt);
					var day = dateObject.getDate().toString().padStart(2, "0");
					var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
					var year = dateObject.getFullYear();

					this.createdAt = `${day}-${month}-${year}`;
				}
			} catch (error) {
				this.errorModal("Error", "An error occurred"); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},
		reassignDetails() {
			this.profileDetails = this.reassign;
		},

		// Method to update the profile
		async saveProfileDetails() {
			try {
				this.$v.profileDetails.$touch();

				// Check if form fields are not invalid
				if (!this.$v.profileDetails.$invalid) {
					this.profileLoader = true;

					// Call the API to update the profile
					const res = await saveProfileDetails(this.profileDetails);
					if (res.status == 200) {
						this.reassign = this.profileDetails;

						this.successModal(
							"Successfully updated",
							"Profile have been updated"
						);

						this.profileLoader = false;

						this.editProfile = false;
						this.callingRegisterAPI();
					} else {
						this.errorModal("Error", "Something went wrong"); // Show error toast
					}
				} else {
					this.errorModal("Error", "Please fill all the fields"); // Show error toast for incomplete fields
				}
			} catch (error) {
				this.errorModal(
					"Error",
					"An error occurred while updating the profile"
				); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},

		async callingRegisterAPI() {
			const res = await userInfo();
			if (res.status == 200) {
				this.$store.commit("userVUEX/setUserInfo", res.data.data);
			}
		},

		// Method to format a timestamp
		formatTimestamp(timestamp) {
			var dateObject = new Date(timestamp * 1000);

			var day = dateObject.getDate().toString().padStart(2, "0");
			var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
			var year = dateObject.getFullYear();
			var hour = dateObject.getHours().toString().padStart(2, "0");
			var minute = dateObject.getMinutes().toString().padStart(2, "0");
			var period = hour >= 12 ? "PM" : "AM";

			var formattedDate = `${day}-${month}-${year} at ${
				hour % 12 || 12
			}:${minute} ${period}`;

			return formattedDate;
		},
		signOutConfirm(j) {
			this.selectedDevice = j;
			console.log(this.selectedDevice, "log");
			this.$bvModal.show("suresignout");
		},

		// Method to sign out of all devices
		async signOutAllDevices() {
			const objectWithCurrentKey = this.device[0].sessions.find((obj) =>
				obj.hasOwnProperty("current")
			);
			const payload = {
				email: this.profileDetails.email,
				userid: objectWithCurrentKey,
			};
			this.$socket.emit("signOutAll", payload);
			const res = await signOutAllDevices(); // Call the API to sign out all devices
			if (res.data.status == "Success") {
				this.$store.dispatch("userVUEX/LogOut");
			}
			this.$bvModal.hide("suresignout");
		},

		// Method to sign out of a specific device
		async signOut(j) {
			this.loading = true;
			try {
				let payload = {
					id: j.id,
				};
				const objectWithCurrentKey = this.device[0].sessions.find((obj) =>
					obj.hasOwnProperty("current")
				);
				if (this.currentlyTrue.id === payload.id) {
					console.log("current user");
					await signOutDevices(payload); // Call the API to sign out of the specific device
					this.$socket.emit("signOut", {
						email: this.profileDetails.email,
						userid: payload,
					});
					localStorage.clear();
					this.$store.dispatch("userVUEX/LogOut");
					this.$router.push(`/login?redirect=${this.$route.fullPath}`);
				} else {
					console.log("not current user");
					const res = await signOutDevices(payload); // Call the API to sign out of the specific device
					if (res.status == 200) {
						this.loading = false;
					}
					this.$socket.emit("signOut", {
						email: this.profileDetails.email,
						userid: payload,
					});
					this.$bvModal.hide("suresignout");

					this.getDeviceActivity(); // Refresh device activity data after sign-out
				}
			} catch (error) {
				this.errorModal("Error", "An error occurred"); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},

		// Method to fetch device activity for the profile
		async getDeviceActivity() {
			if (this.showMainPage == false) {
				this.showDeviceActivityShimmer = true;
			}
			try {
				const response = await getDeviceActivity(this.profileDetails);
				this.device = response.data;
				console.log(this.device, "dev");

				this.device.forEach((deviceItem, index) => {
					const sessions = deviceItem.sessions;
					this.deviceCheck = deviceItem.sessions;
					console.log(this.deviceCheck, "dev");
					const currentIndex = sessions.findIndex(
						(item) => item.current === true
					);

					if (currentIndex !== -1) {
						this.currentlyTrue = sessions[currentIndex];
					}

					sessions.forEach((session) => {
						session.lastAccess = this.formatTimestamp(session.lastAccess);
						session.started = this.formatTimestamp(session.started);
						session.expires = this.formatTimestamp(session.expires);
					});
				});

				this.showDeviceActivityShimmer = false;
			} catch (error) {
				this.errorModal("Error", "An error occurred");
			}
		},
	},
};
</script>

<style>
.mb-profile-inputField {
	border-radius: 10px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--base-white, #fff);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	color: #333;
	font-size: 14px;
	font-weight: 500;
	/* padding: 18px 10px; */
	/* height: 32px; */
}

.mb-profile-inputField-error {
	border-radius: 10px;
	border: 1px solid #eb0002;
	background: var(--base-white, #fff);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	color: #333;
	font-size: 14px;
	font-weight: 500;
	/* padding: 18px 10px; */
	/* height: 32px; */
}

.mb-profile-inputField:focus {
	box-shadow: none;
}

.mb-profile-inputField-error:focus {
	box-shadow: none;
	border: 1px solid #eb0002;
}

.mb-profile-inputField:disabled {
	background: #ebebeb;
	opacity: 0.65;
	border: unset;
}
.no-resume-text {
	color: #333333;
	font-size: 16px;
	font-weight: 600;
}

.mb-acsec-bluecard {
	background-color: #ffffff;
	border-radius: 4px;
	padding: 14px 15px;
}

.mb-acsec-bluecard-sel {
	background-color: #20639b0a;
	border-radius: 8px;
	padding: 7px 12px;
	border: 1px solid #20639b;
}

.mb-light-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 11px;
	font-weight: 400;
	color: #696969;
}

.mb-dark-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #2c2c2c;
}
.started-at {
	color: #7a7a7a;
	font-size: 13px;
	font-weight: 500;
	font-family: "Montserrat";
}
.color-904EE2 {
	color: #904ee2;
}
.color-00AE1C {
	color: #00ae1c;
}
.color-AD1927 {
	color: #ad1927;
}
</style>
